import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { type Employee } from '@avanta/shared/types/employees';
import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS } from 'constants/common';
import { ROUTES } from 'constants/routes';
import { EmployeeService } from 'services/employees';

export const useUpdateEmployee = (): UseMutationResult<Employee, Error, Employee> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.AUTH);
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_EMPLOYEE],
    mutationFn: async (employee: Employee) => {
      const response = await EmployeeService.updateEmployee({ ...employee });
      return response.data;
    },
    onSuccess: user => {
      queryClient.setQueryData([QUERY_KEYS.FETCH_USER], () => ({
        data: { ...user, requiredProfileSetup: false },
      }));
      toast.success(t('SignupForm.update.success'));
      navigate(ROUTES.HOME);
    },
  });
};
